export default __webpack_public_path__ + "static/media/ic_truck.2dc537a1.svg";